import { com } from '@eidu/web'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import EntityWithLabelAndRelated from '../domain/entity/EntityWithLabelAndRelated'
import { fetchEntitiesByIds, getOrFetchTypes } from './useEntities'
import { entityKeys } from './queryKeys'
import EntityId = com.eidu.sharedlib.entity.EntityId

type UseEntityByIdResult = { entity: EntityWithLabelAndRelated | null | undefined; loading: boolean }

const useEntityById = (id: EntityId | undefined): UseEntityByIdResult => {
  const queryClient = useQueryClient()

  const query = useQuery({
    queryKey: id ? entityKeys.detail(id) : ['_no_entity'],
    // Fetch the entity directly instead of going through useFetchEntity — the latter wraps the same queryKey in
    // queryClient.fetchQuery, which would re-enter this query and deadlock on the in-flight promise.
    queryFn: async () => {
      const types = await getOrFetchTypes(queryClient)
      const result = await fetchEntitiesByIds([id!], types)
      return result.get(id!) ?? null
    },
    enabled: !!id,
  })

  if (!id) return { entity: undefined, loading: false }
  if (query.isError) return { entity: null, loading: false }
  return { entity: query.data, loading: query.isLoading }
}

export default useEntityById
